import { Directive, HostListener, Renderer2, AfterViewInit } from '@angular/core';

import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { ThemeService } from '../services/theme.service';

@Directive({
  selector: '[artemisThemeSwitcher]'
})
export class ThemeSwitcherDirective implements AfterViewInit {

  currentTheme: string;

  @HostListener('change', ['$event']) valueChanged($event: any) {
    if ($event instanceof MatSlideToggleChange) {
      this.renderer.removeClass(document.body, this.currentTheme);
      this.currentTheme = this.getNewTheme(this.currentTheme);
      this.renderer.addClass(document.body, this.currentTheme);

      this.themeService.setTheme(this.currentTheme);
      localStorage.setItem('theme', this.currentTheme);
    }
  }

  constructor(private renderer: Renderer2,
              private themeService: ThemeService) { }

  ngAfterViewInit() {
    if (localStorage.getItem('theme')) {
      this.currentTheme = localStorage.getItem('theme');
      this.renderer.addClass(document.body, this.currentTheme);
    } else {
      this.renderer.addClass(document.body, 'theme_dark');
      localStorage.setItem('theme', 'theme_dark');
    }

    this.themeService.setTheme(this.currentTheme);
  }

  private getNewTheme(currentTheme: string): string {
    switch (currentTheme) {
      case 'theme_dark':
        return 'theme_light';
        break;

      case 'theme_light':
        return 'theme_dark';
        break;

      default:
        return 'theme_dark';
        break;
    }
  }
}
